import { render, staticRenderFns } from "./Telematics.html?vue&type=template&id=20271e9d&scoped=true&external"
import script from "./Telematics.js?vue&type=script&lang=js&external"
export * from "./Telematics.js?vue&type=script&lang=js&external"
import style0 from "./Telematics.scss?vue&type=style&index=0&id=20271e9d&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20271e9d",
  null
  
)

export default component.exports